import React from "react";
import { useField, useFormikContext } from "formik";
import { Select } from "antd";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";
import { get } from 'lodash'
const { Option } = Select;

const getFieldCSSClasses = (touched, errors) => {
  const classes = []; // ["form-control", "form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function AntdSelect({
  label,  
  name,
  children,
  multiple = false,
  customFeedbackLabel,
  withFeedbackLabel = true,
}) {
  const { setFieldValue, setFieldTouched, errors, touched } = useFormikContext();
  const [field] = useField(name);

  const touchedResult = get(touched, field.name);
  const errorsResult = get(errors, field.name);

  return (
    <>
      {label && (
        <div className="d-flex justify-content-between align-items-center mb-1">
          <label className="mb-0">{label}</label>
          {multiple && (
            <div className="d-flex" style={{ gap: "10px" }}>
              <span
                className="text-primary cursor-pointer text-hover-underline"
                style={{ fontSize: "11px", cursor: "pointer" }}
                onClick={() => setFieldValue(field.name, children?.map((c) => c.id) || [])}
              >
                Select All
              </span>
              <span
                className="text-danger cursor-pointer text-hover-underline"
                style={{ fontSize: "11px", cursor: "pointer" }}
                onClick={() => setFieldValue(field.name, [])}
              >
                Deselect All
              </span>
            </div>
          )}
        </div>
      )}
      <Select
        showSearch
        size='large'
        style={{ width: '100%' }}
        value={field.value}
        {...multiple && { mode: "multiple" }}
        onChange={(value) => setFieldValue(field.name, value)}
        onBlur={() => setFieldTouched(field.name, true)}
        className={getFieldCSSClasses(touchedResult, errorsResult)}
        status={errorsResult ? 'error' : ''}
        placeholder={`Please Select ${label}`}
        optionFilterProp="children"
      >
        {children && children.map((child) => {
          return (
            <Option value={child.id} key={child.id} name={child.name || child.label}>
              {child.name || child.label}
            </Option>
          );
        })}
      </Select>
      {withFeedbackLabel && (
        <FieldFeedbackLabel
          error={errorsResult}
          touched={touchedResult}
          label={label}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
